import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { AuthService } from './services/auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { catchError, EMPTY, Subject, switchMap, takeUntil } from 'rxjs';

@Component({
    selector: 'app-auth',
    templateUrl: './auth.component.html',
    styleUrls: ['./auth.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AuthComponent implements OnInit, OnDestroy {
  destroyRef$ = new Subject<void>();
  hidePwd = true;
  loading = false;

  loginForm = new UntypedFormGroup({
    login: new UntypedFormControl('', [
      Validators.required,
      Validators.minLength(4),
    ]),
    password: new UntypedFormControl('', [
      Validators.required,
      Validators.minLength(8),
    ]),
  });

  constructor(
    private authService: AuthService,
    private snackBar: MatSnackBar,
    private router: Router
  ) {
  }

  ngOnInit(): void {
    if (this.authService.isLoggedIn()) {
      this.router.navigate(['/materials']);
    }
  }

  onSubmit(): void {
    this.loading = true;

    this.authService.login(this.loginForm.get('login')?.value, this.loginForm.get('password')?.value)
      .pipe(
        takeUntil(this.destroyRef$),
        catchError(() => {
          this.snackBar.open('Невірний логін чи пароль', 'ok', {
            duration: 3000
          });
          this.loading = false;
          return EMPTY;
        }),
        switchMap(() => this.authService.init()),
      )
      .subscribe(() => {
        window.location.href = '/';
        this.loading = false;
      });
  }

  ngOnDestroy(): void {
    this.destroyRef$.next();
    this.destroyRef$.complete();
  }
}
